import React from 'react';
import { Form, Input } from 'antd';
import { NamePath } from 'rc-field-form/lib/interface';

type TextAreaInputProps = {
  name: NamePath;
  label: string;
  value?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
  rows?: number;
  formItemStyle?: React.CSSProperties;
  showCount?: boolean;
  maxLength?: number;
};

export function TextAreaInput(props: TextAreaInputProps) {
  const handleChange = (value: string) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <>
      <Form.Item name={props.name} style={props.formItemStyle} label={props.label} rules={[{ required: props.required, message: `${props.label} is required` }]}>
        <Input.TextArea
          value={props.value}
          maxLength={props.maxLength ?? 1000}
          rows={props.rows}
          onChange={(event) => {
            handleChange(event.target.value);
          }}
          onPressEnter={(event) => {
            handleChange(event.currentTarget.value);
          }}
          disabled={props.disabled}
          placeholder={props.placeholder}
          showCount={props.showCount}
        />
      </Form.Item>
    </>
  );
}
